import http from 'axios'
import urls from './manageUsers.urls'

export default {
  getUserGroups: ({ state, rootState, commit }) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .get(urls.userGroups)
      .then(response => {
        commit('setUserGroups', response.data)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  getUsersForUserGroup: ({ state, rootState, commit }, selectedUserGroup) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    commit('setSelectedUserGroupInformation', selectedUserGroup)
    commit('setUsersForUserGroup', [])
    return http
      .get(urls.usersByUserGroup(selectedUserGroup.userGroupId))
      .then(response => {
        commit('setUsersForUserGroup', response.data)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  getUsers: ({ state, rootState, commit }) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .get(urls.users)
      .then(response => {
        commit('setUserList', response.data)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  getUserGroupsForUser: ({ state, rootState, commit }, user) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    commit('setSelectedUser', user)
    return http
      .get(urls.userGroupsByUser(user.userSeq))
      .then(response => {
        commit('setUserGroupsForUser', response.data)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  addUserGroupForUser: ({ state, rootState, commit, dispatch }, data) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .put(urls.addToUserGroup(data.user.userSeq, data.group.userGroupId))
      .then(response => {
        dispatch('getUserGroupsForUser', data.user)
        dispatch('getUserGroupHistoryForUser', data.user)
        dispatch('getUserHistoryForUserGroup', data.group)
        dispatch('getUsersForUserGroup', data.group)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  delUserGroupForUser: ({ state, rootState, commit, dispatch }, data) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .delete(urls.delUserFromUserGroup(data.user.userSeq, data.group.userGroupId))
      .then(response => {
        dispatch('getUserGroupsForUser', data.user)
        dispatch('getUserGroupHistoryForUser', data.user)
        dispatch('getUserHistoryForUserGroup', data.group)
        dispatch('getUsersForUserGroup', data.group)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  getUserGroupHistoryForUser: ({ state, rootState, commit }, user) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .get(urls.userGrouptoUserHistory(user.userSeq))
      .then(response => {
        commit('setUserHistory', response.data)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  getUserHistoryForUserGroup: ({ state, rootState, commit }, userGroup) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    commit('setUserGroupHistory', [])
    return http
      .get(urls.usertoUserGroupHistory(userGroup.userGroupId))
      .then(response => {
        commit('setUserGroupHistory', response.data)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  }
}
